<template>
  <div class="service-file-list-item service-file-list-item-pdf">
    <div class="top" @click="dialogVisible = true">
      <div>
        <img src="@/assets/service/文档.png" />
      </div>
    </div>
    <div class="bottom">
      <div>
        <img src="@/assets/service/pdf.png" alt /> PDF
      </div>
      <div class="download" @click="onDownload"></div>
    </div>

    <el-dialog :visible.sync="dialogVisible" fullscreen>
      <iframe
        :src="this.util.getImageUrl(this.item.url)"
        frameborder="0"
        width="100%"
        height="800px"
      ></iframe>
      <span slot="title"></span>
      <span slot="footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import UUID from "uuid/v5";
import PDFObject from "pdfobject";

import FileListItem from "./FileListItem";
export default {
  name: "FileListItemPdf",
  extends: FileListItem,
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      id: UUID(this.item.url, UUID.URL),
      dialogVisible: false
    };
  },
  mounted() {
    PDFObject.embed(this.util.getImageUrl(this.item.url), "#pdf_viewer");
  }
};
</script>

<style lang="scss">
.service-file-list-item-pdf {
  background: linear-gradient(
    360deg,
    rgba(238, 153, 154, 1) 0%,
    rgba(255, 227, 228, 1) 100%
  );
  border-radius: 5px;

  .top {
    cursor: pointer;
  }

  .pdf {
    width: 100%;
    height: 50vh;
  }

  .el-dialog {
    background: black;
  }
}
</style>